import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import InfoCamp from '../infoCamp'

import { updatePauta } from 'redux/actions/objectCampain.actions'

const UpdateCampain = (props) => {
  let closeModal = () => {
    let shadow = document.getElementById('shadow')
    let modal = document.getElementById('ModalUpdCamp')
    shadow.classList.toggle('hide')
    modal.classList.toggle('hide')
  }

  let saveName2 = () => {
    let name = document.getElementById('btnNameCamp2')
    let conTitle = document.getElementById('Contitulo')
    let tituloTxt = document.getElementById('titulo')

    let content = document.getElementById('ConMedio')

    if (name.value.trim().length > 0) {
      tituloTxt.textContent = name.value
      tituloTxt.classList.add('insert')
      conTitle.classList.remove('ene-view')
      content.classList.add('ene-view')
      console.log('#############################')
      console.log(props.pauta[0].namee)

      props._updatePauta(props.pauta[0].ide, name.value, 1)
      closeModal()
      //props._saveSteps(2)
    } else {
      name.style.borderBottom = '1px solid red'
      name.placeholder = 'Este texto es requerido'
      name.classList.add('require')
      console.log('############################# else')
      console.log(props.pauta[0].namee)
    }
  }

  var nomb = ''

  if (props.pauta != null && props.pauta.length > 0) {
    nomb = props.pauta[0].namee
  }

  return (
    <div className='form'>
      <div className='form-margin'>
        <div className='left-form'>
          <div className='component'>
            <h1 className='title'>Ingresa el nuevo nombre de la pauta</h1>
            <input
              className='input'
              id='btnNameCamp2'
              type='text'
              defaultValue={nomb}
            ></input>
            <div className='rigth-btn'>
              <a
                className='btn-camp'
                onClick={saveName2}
                href='#'
                id='nextName2'
              >
                siguiente
              </a>
            </div>
          </div>
        </div>
        <InfoCamp />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  campaign: state.campaign,
  pauta: state.pauta,
})

const mapDispatchToProps = (dispatch) => ({
  _updatePauta: (id, name, status) =>
    dispatch(
      updatePauta(id, name, status)
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateCampain))